import { Modal } from '@mantine/core';
import { useEffect } from 'react';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { SectionDraftsModalBody } from './SectionDraftsModalContent';
import { useSuitabilityReportDrafts } from './useSuitabilityReportDrafts';

type SuitabilityReportDraftsModalProps = {
  suitabilityReportId: string | null;
  companyId: string;
  onClose: () => void;
};

export function SuitabilityReportDraftsModal({
  suitabilityReportId,
  companyId,
  onClose,
}: SuitabilityReportDraftsModalProps) {
  const { data, isLoading, isError, error } = useSuitabilityReportDrafts(
    companyId,
    suitabilityReportId,
  );

  useEffect(() => {
    if (isError) {
      notifyAndLogError(
        'Failed to load section drafts',
        'Could not fetch section drafts for this suitability report.',
        error,
        { suitabilityReportId },
      );
    }
  }, [isError, error, suitabilityReportId]);

  return (
    <Modal
      opened={!!suitabilityReportId}
      onClose={onClose}
      title={`Suitability report: ${suitabilityReportId ?? ''}`}
      size={1200}
    >
      <SectionDraftsModalBody drafts={data?.drafts} isLoading={isLoading} isError={isError} />
    </Modal>
  );
}
